var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTreinamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.525,
    height: 42.164,
    viewBox: "0 0 50.525 42.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:gray;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.943,42.164a4.823,4.823,0,0,1-2.321-.6l-12.084-6.6a4.845,4.845,0,0,1-2.512-4.255V23.925l14.6,7.974a4.8,4.8,0,0,0,4.64,0l14.6-7.974v6.789a4.844,4.844,0,0,1-2.515,4.255l-12.084,6.6A4.812,4.812,0,0,1,23.943,42.164Zm24.166-9.008a2.419,2.419,0,0,1-2.416-2.416V16.458L26.262,27.067a4.8,4.8,0,0,1-4.64,0L1.25,15.95a2.434,2.434,0,0,1,0-4.253L21.622.579a4.94,4.94,0,0,1,4.64,0L49.271,13.123a2.416,2.416,0,0,1,1.255,2.125V30.74A2.418,2.418,0,0,1,48.109,33.156Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTreinamento);
export default __webpack_public_path__ + "static/media/ic_treinamento.f2cb4340485c2d922171816e7176752f.svg";
export { ForwardRef as ReactComponent };